import constants from '../../constants/app-constants';

export const selectedCurrency = currency => {
  return {
    type: constants.shared.SET_CURRENCY,
    payload: currency
  };
};
